import { useParams } from "react-router-dom";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignups } from "Signups/state";

import { signupItemStateHooks } from "../../stateHooks";

const defaultObject = {};

const useTabKey = () => {
  const { signupItemTab } = useParams();

  return signupItemTab;
};

const useBaseUrl = () => {
  const [
    {
      currentSignupList: { ID: signupListID },
    },
  ] = useSignups();
  const { signupItemID } = useParams();

  return `/signups/${signupListID}/items/${signupItemID}/`;
};

const useIsNew = () => {
  const [
    {
      currentSignupList: { signupItems },
    },
  ] = useSignups();
  const { signupItemID } = useParams();
  const { lastCreatedSignupItemID } = useNewSignupCreationFlow();

  return (
    signupItemID === "new" ||
    (lastCreatedSignupItemID === parseInt(signupItemID) &&
      signupItems?.length === 1)
  );
};

const useIsAdminOfAnyGroup = () => {
  const [
    {
      user: { isAdminOfAnyGroup },
    },
  ] = useSignups();

  return isAdminOfAnyGroup;
};

const useShowRespondentsTab = () => {
  const { isInCreationFlow } = useNewSignupCreationFlow();
  const isNew = useIsNew();
  const isAdminOfAnyGroup = useIsAdminOfAnyGroup();

  return !isInCreationFlow && !isNew && isAdminOfAnyGroup;
};

const useHasFund = () => {
  const [
    {
      currentSignupList: {
        fundIt: { fund },
      },
    },
  ] = useSignups();
  return fund?.ID > 0;
};

const useHasDisabledFundItViaItem = () => {
  const [
    {
      currentSignupList: { hasDisabledFundItViaItem },
    },
  ] = useSignups();
  return hasDisabledFundItViaItem;
};

const useSignupItem = () => {
  const { signupItem, setSignupItem } = signupItemStateHooks.useGetSignupItem();
  return [signupItem || defaultObject, setSignupItem];
};

const useSlotsTaken = () => {
  const [{ slotsTaken }] = useSignupItem();
  return slotsTaken;
};

const useIsOnlyItem = () => {
  const [
    {
      currentSignupList: { signupItems },
    },
  ] = useSignups();
  return signupItems.length === 1;
};

const useIsLoading = () => {
  const { isLoading } = signupItemStateHooks.useGetSignupItem();

  return isLoading;
};

const useItemNotCreatedYet = () => {
  const { lastCreatedSignupItemID } = useNewSignupCreationFlow();
  const { signupItemID } = useParams();

  return lastCreatedSignupItemID !== parseInt(signupItemID);
};

const useAdditionalInfoDisabled = () => {
  const isNew = useIsNew();
  const itemNotCreatedYet = useItemNotCreatedYet();
  const { forceToAddItem } = useNewSignupCreationFlow();

  return (isNew && itemNotCreatedYet) || forceToAddItem;
};

const useTakePaymentsDisabled = () => {
  const isNew = useIsNew();
  const itemNotCreatedYet = useItemNotCreatedYet();
  const { forceToAddItem } = useNewSignupCreationFlow();

  return (isNew && itemNotCreatedYet) || forceToAddItem;
};

const useRespondentsDisabled = () => {
  const isNew = useIsNew();
  const { forceToAddItem } = useNewSignupCreationFlow();
  return isNew || forceToAddItem;
};

const useTransitioningToNewItem = () => {
  const { signupItemID } = useParams();
  const [item] = useSignupItem();
  return (
    parseInt(item?.ID) !== parseInt(signupItemID) && item?.ID !== signupItemID
  ); // happens while fetching the item after navigating to new item
};
export {
  useBaseUrl,
  useShowRespondentsTab,
  useHasFund,
  useHasDisabledFundItViaItem,
  useSlotsTaken,
  useTabKey,
  useIsNew,
  useIsOnlyItem,
  useIsLoading,
  useSignupItem,
  useItemNotCreatedYet,
  useAdditionalInfoDisabled,
  useTakePaymentsDisabled,
  useRespondentsDisabled,
  useTransitioningToNewItem,
};
